export const educationData = [
  {
    degree: "MSc. Finance",
    institution: 'London School of Economics and Political Science',
    location: 'London, UK',
    period: '2016 - 2018',
    details: [
      'Financial Engineering, Risk Management in Financial Markets, Portfolio Management, Fixed Income Securities and Credit Markets',
      'Dissertation: Comparison of tail risk calculations - extracting RNP distribution from option prices using Breeden Litzeberger method and comparing that to CBOE volatility indexes (VIX, VVIX, SKEW)'
    ],
  },
  {
    degree: "BEng. Computer Science",
    institution: 'University of Pune',
    location: 'Pune, India',
    period: '1999 - 2003',
    details: [
      'Computer Science',
      'Information Technology'
    ],
  }
];
